module.exports = __webpack_public_path__ + "img/full5-min.fdb9257e.png";